// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1cXRx","signatureButtonsRight":"ModalSign_signatureButtonsRight__3YSzO"};